import React from 'react'
import cs from 'classnames'
import styles from 'elements/CookieBanner.scss'

const CookieBanner = ({children, className, buttonText, handleAcceptCookies}) => {
	return (
		<div className={cs(styles.mainCon, className)}>
			<div className={styles.textCon}>
				{children}
			</div>
            <div className={styles.buttonWrapper}>
                <button onClick={() => { handleAcceptCookies()}}>
                    {buttonText}
                </button>
            </div>
		</div>
	)
}
export default CookieBanner



// WEBPACK FOOTER //
// ./elements/CookieBanner.jsx